import React from "react";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";
import styled from "styled-components";
import { PositionContextType } from "../controller/UserController";

export const BackLayout = () => {
  const navigate = useNavigate();
  const { position } = useOutletContext<PositionContextType>();

  return (
    <Style>
      <div className="screen">
        <div className="backButton">
          <img
            onClick={() => navigate(-1)}
            src={`${process.env.PUBLIC_URL}/svg/ic_back.svg`}
            alt="speaking"
          />
        </div>
        <div className="backScreen">
          <Outlet
            context={{
              position: position,
            }}
          />
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  .screen {
    display: flex;
    width: 100%;
    height: 100%;
    background: #000000;
  }
  .backButton {
    width: 5%;
    padding-top: 1%;
    padding-left: 0.5%;
    img {
      width: 100%;
    }
  }
  .backScreen {
    width: 100%;
    height: 100%;
    min-height: auto;
    padding-right: 5%;
  }
`;
